export default {"src":"/_next/static/media/ice-climbing-atlas.cafde31b.svg","height":39,"width":38,"blurWidth":0,"blurHeight":0};